import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    virtual: {
        id: 'cardType.virtual',
        defaultMessage: 'Virtual',
    },
    plastic: {
        id: 'cardType.plastic',
        defaultMessage: 'Plastic',
    },
    recurring: {
        id: 'cardType.recurring',
        defaultMessage: 'Recurring',
    },
    temporary: {
        id: 'cardType.temporary',
        defaultMessage: 'Temporary',
    },
});

export default enumMessages;
